import React from 'react'

import * as UI from '../../components'
import { formatDateTime, formatCoin, getTransactionURL } from '../../helpers'

export default ({ payments }) =>
  payments && (
    <UI.List>
      {payments.map(payment => (
        <UI.List.Item key={payment.key}>
          <UI.List.Header>
            <UI.Link to={getTransactionURL(payment)} target="_blank">
              {formatCoin(payment.amount, payment.currency)}
            </UI.Link>
            &nbsp;{' '}
            <UI.Text inline color="accent">
              ({payment.status})
            </UI.Text>
          </UI.List.Header>

          <UI.List.Description>
            {formatDateTime(payment.receivedTime)}
          </UI.List.Description>
        </UI.List.Item>
      ))}
    </UI.List>
  )



// WEBPACK FOOTER //
// ./src/screens/partials/PaymentsList.js